export default function CoreValues() {
  const values = [
    {
      icon: 'ri-scales-3-line',
      title: '機會平等',
      subtitle: 'Equity',
      description: '讓弱勢背景的青年擁有與他人相近的發展起點,消除因出身而產生的機會落差。'
    },
    {
      icon: 'ri-plant-line',
      title: '潛力培育',
      subtitle: 'Potential',
      description: '評選重視品格、動機與影響力,而非單一成績或學歷,發掘真正具有成長潛力的青年。'
    },
    {
      icon: 'ri-refresh-line',
      title: '循環共好',
      subtitle: 'Reciprocity',
      description: '期待獲獎者未來成為下一代青年的支持者,形成世代善循環,讓愛與支持不斷延續。'
    }
  ];

  return (
    <section id="core-values" className="py-24 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-sm text-gray-500 mb-6 tracking-wider">CORE VALUES</p>
          <h2 className="text-6xl font-bold text-gray-900 leading-tight">
            機會平等<br />
            潛力培育<br />
            循環共好
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-white/60 rounded-2xl p-10">
              <div className="mb-6">
                <i className={`${value.icon} text-5xl text-gray-900 w-12 h-12 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{value.title}</h3>
              <p className="text-sm text-gray-500 mb-4 font-light italic">{value.subtitle}</p>
              <p className="text-base text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
